<canvas ChartJsDirective [options]="options" [style.height]="height" style=" width: auto;">{{ chart }}</canvas>
